import React, { memo } from 'react'

import banner from 'assets/images/go-resale@2x.png'
import styles from './PagesBanner.module.scss'

const PageBanner = ({ title, aboutPage = false }) => {
  const headerClass = aboutPage ? 'aboutBanner' : 'pageBanner'

  return (
    <header className={styles[headerClass]}>
      <h1>{title}</h1>
      {aboutPage && (
        <img
          loading="lazy"
          src={banner}
          alt="#goresale"
          className={styles.image}
        />
      )}
    </header>
  )
}

export default memo(PageBanner)
